import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=705fcf68&"
import script from "./CustomHeader.vue?vue&type=script&lang=ts&"
export * from "./CustomHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
